module.exports = __webpack_public_path__ + "img/worker-robots-storage.e71bddd5.png";